import type { Messages } from './messages';

export const es = {
  common: {
    back: 'Atrás',
    next: 'Siguiente',
    submit: 'Enviar',
    submitting: 'Enviando…',
    cancel: 'Cancelar',
    loading: 'Cargando…',
    retry: 'Reintentar',
    required: 'Requerido',
    close: 'Cerrar',
    confirm: 'Confirmar',
    yes: 'Sí',
    no: 'No',
    error: 'Error',
    tryAgain: 'Por favor intenta de nuevo.',
    networkError:
      'Problema de red. Verifica tu conexión e intenta de nuevo — no se envió dos veces.',
  },
  shopStatus: {
    open: 'Abierto',
    closedToday: 'Cerrado hoy',
    beforeOpen: 'Abrimos pronto',
    afterClose: 'Cerrado por hoy',
    registrationCutoff: 'El registro de walk-in está cerrado por hoy',
    manuallyPaused: 'No estamos aceptando walk-ins en este momento',
    manuallyClosed: 'No estamos aceptando walk-ins en este momento',
    walkInsAvailable: 'Walk-ins disponibles',
    walkInsClosed: 'El registro de walk-in está cerrado',
  },
  barbers: {
    nextAvailable: 'Próximo Disponible',
    noneAvailable: 'Ningún barbero está aceptando nuevos clientes en este momento.',
    label: 'Barbero preferido',
  },
  checkIn: {
    title: 'Únete a la Lista de Espera',
    subtitle: 'Ingresa tu número de teléfono para comenzar — solo toma unos segundos.',
    phoneLabel: 'Número de teléfono',
    phonePlaceholder: '(980) 255-8167',
    lookupButton: 'Continuar',
    welcomeBack: 'Bienvenido de nuevo, {{name}}.',
    notYou: '¿No eres tú?',
    updateInfo: 'Actualizar mi información',
    firstNameLabel: 'Nombre',
    lastNameLabel: 'Apellido',
    emailLabel: 'Correo electrónico',
    marketingConsentLabel:
      'Envíenme noticias, ofertas y promociones ocasionales de Nine80 Hair Studio por correo electrónico.',
    submitButton: 'Unirme a la lista',
    honeypotLabel: 'Deja este campo en blanco',
    errorInvalidPhone: 'Ingresa un número de teléfono válido de EE. UU. (10 dígitos).',
    errorInvalidEmail: 'Ingresa un correo electrónico válido.',
    errorInvalidName: 'Ingresa un nombre válido.',
    errorQueueClosed:
      'El registro de walk-in ha cerrado por hoy. Si ya estás en la tienda, avisa a un miembro del personal.',
    errorBarberUnavailable:
      'Ese barbero ya no está aceptando nuevos clientes. Elige otro barbero o Próximo Disponible.',
    errorAlreadyOnList: 'Ya estás en la lista.',
    confirmationTitle: 'Ya estás en la lista.',
    confirmationRequested: 'Solicitado: {{barber}}',
    confirmationAhead: '{{count}} clientes actualmente delante de ti.',
    confirmationAheadSingular: '{{count}} cliente actualmente delante de ti.',
    confirmationRemoteHint:
      'Cuando llegues, abre esta página y toca "Ya Llegué", o avísale a un miembro del personal.',
    confirmationViewStatus: 'Ver mi estado',
  },
  status: {
    title: 'Tu Estado en la Lista',
    requestedFor: 'Solicitado: {{barber}}',
    aheadPlural: '{{count}} clientes actualmente delante de ti.',
    aheadSingular: '{{count}} cliente actualmente delante de ti.',
    aheadZero: 'Eres el siguiente entre tus barberos elegibles.',
    presentYes: 'Estás marcado como presente en la tienda.',
    presentNo: 'Aún no te tenemos marcado como llegado.',
    imHereButton: 'Ya Llegué',
    imHereConfirmed: 'Gracias — estás marcado como llegado.',
    cancelButton: 'Salir de la lista de espera',
    cancelConfirmTitle: '¿Salir de la lista de espera?',
    cancelConfirmBody: 'Perderás tu lugar en la fila. Siempre puedes volver a unirte después.',
    cancelled: 'Has salido de la lista de espera.',
    statusWaiting: 'Esperando',
    statusInChair: 'En la silla',
    statusCompleted: '¡Completado — gracias por venir!',
    statusNoShow: 'Marcado como no-show',
    statusCancelled: 'Cancelado',
    statusRemoved: 'Eliminado de la lista',
    contactTitle: 'Nine80 Hair Studio',
  },
  kiosk: {
    welcomeTitle: 'Bienvenido a Nine80 Hair Studio',
    welcomeSubtitle: 'Toca abajo para registrarte para un corte walk-in.',
    checkInButton: 'Registrarme',
    queueTitle: 'Esperando actualmente',
    noOneWaiting: 'Nadie está esperando actualmente. ¿Walk-in? Regístrate abajo.',
    staffAccess: 'Personal',
    languageToggle: 'English',
    inactivityPrompt: '¿Sigues ahí?',
    inactivityContinue: 'Sí, continuar',
    confirmationTitle: '¡Estás registrado!',
    confirmationBody: 'Un miembro del personal dirá tu nombre cuando sea tu turno.',
    returningPrompt: '¡Bienvenido de nuevo!',
    newCustomerPrompt: 'Parece que eres nuevo aquí.',
  },
  staff: {
    loginTitle: 'Inicio de Sesión del Personal',
    pinLabel: 'PIN',
    loginButton: 'Entrar',
    loggingIn: 'Entrando…',
    invalidPin: 'PIN incorrecto.',
    rateLimited: 'Demasiados intentos. Espera unos minutos e intenta de nuevo.',
    logoutButton: 'Cerrar Sesión',
    queueTitle: 'Fila de Walk-In',
    emptyQueue: 'La fila está vacía.',
    present: 'Presente',
    markPresent: 'Marcar Presente',
    inChairButton: 'En Silla',
    completeButton: 'Completar',
    noShowButton: 'No-Show',
    removeButton: 'Eliminar',
    reassignLabel: 'Barbero',
    barberStatusLabel: 'Estado',
    statusAvailable: 'Disponible',
    statusOnBreak: 'En Descanso',
    statusDoneForDay: 'Terminó por Hoy',
    waitingMinutes: '{{minutes}}m esperando',
    actingAsLabel: 'Actuando como',
    selectBarberPrompt: 'Selecciona un barbero',
    alreadyTaken: 'Este cliente ya fue tomado por otro barbero.',
    confirmRemoveTitle: '¿Eliminar a este cliente?',
    confirmRemoveBody: 'Esto lo elimina de la fila activa. La visita queda registrada.',
    languageToggle: 'English',
  },
} satisfies Messages;
